export const HTTP_COLLECTION_TYPE = ['http', 'frontEndHttp', 'code', 'sql'];
export const DB_COLLECTION_TYPE = ['db', 'db_join', 'wuji1_0', 'er', 'combineData'];
export function isHttpCollection(type) {
  return HTTP_COLLECTION_TYPE.includes(type);
}
export function isDbCollection(type) {
  return DB_COLLECTION_TYPE.includes(type);
}
//# sourceMappingURL=collectionType.js.map
